import store from 'utils/store/withMiddleware'
import moneyFormat from 'utils/format/money'
import { countDependents } from '@hc-frontend/business'
import getValueFees from './getValueFees'
import getBaseRate from './getBaseRate'

const latitudeFees = [
  {
    name: 'selectIndividual',
    description: 'Select Individual',
    value: 17.6
  },
  {
    name: 'selectIndividualNoHi',
    description: 'Select Individual',
    value: 16.93
  },
  {
    name: 'selectIndividualNoCi',
    description: 'Select Individual',
    value: 14.29
  },
  {
    name: 'selectFamily',
    description: 'Select Family',
    value: 34.63
  },
  {
    name: 'selectFamilyNoHi',
    description: 'Select Family',
    value: 32.82
  },
  {
    name: 'selectFamilyNoCi',
    description: 'Select Family',
    value: 26.75
  },
  {
    name: 'preferredIndividual',
    description: 'Preferred Individual',
    value: 27.43
  },
  {
    name: 'preferredIndividualNoHi',
    description: 'Preferred Individual',
    value: 26.08
  },
  {
    name: 'preferredIndividualNoCi',
    description: 'Preferred Individual',
    value: 20.8
  },
  {
    name: 'preferredFamily',
    description: 'Preferred Family',
    value: 53.23
  },
  {
    name: 'preferredFamilyNoHi',
    description: 'Preferred Family',
    value: 49.59
  },
  {
    name: 'preferredFamilyNoCi',
    description: 'Preferred Family',
    value: 37.46
  }
]

function getMembership(plan): number {
  let membership = 0
  const isSelect = /select/i.test(plan.planName)
  const isPreferred = /preferred/i.test(plan.planName)
  const isNoCi = /no-hi/i.test(plan.legacyId) && /no-ci/i.test(plan.legacyId)
  const isNoHi = /no-hi/i.test(plan.legacyId) && !/no-ci/i.test(plan.legacyId)
  const members = countDependents(store.getState().hcStorage.members)

  if (!members && isSelect) {
    membership = isNoHi
      ? getValueFees('selectIndividualNoHi', plan.durations[0].monthly.fees, 0)
      : isNoCi
      ? getValueFees('selectIndividualNoCi', plan.durations[0].monthly.fees, 0)
      : getValueFees('selectIndividual', plan.durations[0].monthly.fees, 0)
  } else if (!members && isPreferred) {
    membership = isNoHi
      ? getValueFees('preferredIndividualNoHi', plan.durations[0].monthly.fees, 0)
      : isNoCi
      ? getValueFees('preferredIndividualNoCi', plan.durations[0].monthly.fees, 0)
      : getValueFees('preferredIndividual', plan.durations[0].monthly.fees, 0)
  } else if (members && isSelect) {
    membership = isNoHi
      ? getValueFees('selectFamilyNoHi', plan.durations[0].monthly.fees, 0)
      : isNoCi
      ? getValueFees('selectFamilyNoCi', plan.durations[0].monthly.fees, 0)
      : getValueFees('selectFamily', plan.durations[0].monthly.fees, 0)
  } else if (members && isPreferred) {
    membership = isNoHi
      ? getValueFees('preferredFamilyNoHi', plan.durations[0].monthly.fees, 0)
      : isNoCi
      ? getValueFees('preferredFamilyNoCi', plan.durations[0].monthly.fees, 0)
      : getValueFees('preferredFamily', plan.durations[0].monthly.fees, 0)
  }

  return membership
}

export function getLatitudeFeesBreakdown(plan): {
  baseRate: number
  membership: number
} {
  const planWithFees = {
    ...plan,
    durations: [{ ...plan.durations[0], monthly: { fees: latitudeFees } }]
  }

  const membership = getMembership(planWithFees)
  const baseRate = getBaseRate(plan) || 0
  return {
    baseRate: baseRate - membership,
    membership
  }
}

export function getLatitudeFees(plan): string {
  const { baseRate, membership } = getLatitudeFeesBreakdown(plan)
  return `*Includes ${moneyFormat(baseRate)} for supplemental insurance and ${moneyFormat(
    membership
  )} for membership, non-insurance benefits and non-insurance membership marketing fee.`
}
